import type { TradeInAemDebugModalType } from "../components/toyota/modals/TradeInAemDebugModal";
import type { MODAL_TRADE_IN_WRAPPER } from "../../shared-logic/features/tradein/utils/modalConstants";

export const MODAL_TRADE_IN_AEM_DEBUG = "tradeInAemDebug";

export type TradeInAemModalIdsType = typeof MODAL_TRADE_IN_AEM_DEBUG | typeof MODAL_TRADE_IN_WRAPPER;
export type TradeInAemModalsType = TradeInAemDebugModalType;
